/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tableColumnSelect.vue?vue&type=template&id=4bfa1e8f&scoped=true"
import script from "./tableColumnSelect.vue?vue&type=script&lang=js"
export * from "./tableColumnSelect.vue?vue&type=script&lang=js"
import style0 from "./tableColumnSelect.vue?vue&type=style&index=0&id=4bfa1e8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa1e8f",
  null
  
)

export default component.exports